import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49011e86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }

const githubPicUrl =
  "https://img.88icon.com/upload/jpg/20210622/fb720f1b29c17acca066e40fcc15fbc2_17304_512_512.jpg!bg";
const githubUrl = "https://github.com/zgh-qian";

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_avatar, { size: 32 }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "github",
              src: githubPicUrl
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_link, {
          style: {"color":"#000000"},
          href: githubUrl,
          hoverable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode("全民制作人")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})